import { HotelUpdateSearchModalType } from "@website/accommodation-ui/hotel-update-search-modal/hotel-update-search-modal.types";

export const useSearchUpdateModal = (
  properties: HotelUpdateSearchModalType
) => {
  const { onUpdateResult, isOpen } = properties;

  return {
    modalProps: {
      open: isOpen,
      onClose: () => undefined,
      showCloseButton: false,
      mobileHeight: "auto" as const,
      animate: "bottom" as const
    },
    message:
      process.env.NEXT_PUBLIC_APP_NAME === "villa"
        ? "قیمت و ظرفیت اقامتگاه‌ها دائما در حال تغییر هستند. برای اطمینان از آخرین قیمت و وضعیت اقامتگاه‌ها٬ لطفا جستجو را بروز‌رسانی نمایید."
        : "قیمت و ظرفیت هتل‌ها دائما در حال تغییر هستند. برای اطمینان از آخرین قیمت و وضعیت هتل‌ها٬ لطفا جستجو را بروز‌رسانی نمایید.",
    title: "بروزرسانی جستجو",
    buttonProps: {
      size: "large" as const,
      children: "بروزرسانی جستجو",
      color: "secondary" as const,
      fullWidth: true,
      onClick: onUpdateResult
    }
  };
};
